import { heroStats } from "@/mocks/kanliao";

const tickerItems = [
  "顶流直播翻车 热度 9824",
  "女星解约风波 · 疑似实锤",
  "剧组深夜密会 同车返沪",
  "双女主剧导演取关主演",
  "音乐节压轴名单曝光",
  "综艺预告一闪而过的身影",
  "编剧下场回应删改争议",
  "周五见剪影被锁定位",
];

export default function SiteHero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      {/* ticker strip */}
      <div className="mt-16 md:mt-[68px] border-b border-background-200 bg-background-50">
        <div className="flex items-stretch overflow-hidden">
          <div className="z-10 flex shrink-0 items-center gap-1.5 bg-accent-500 px-4 py-2 text-xs font-bold text-foreground-950">
            <i className="ri-flashlight-fill text-sm" aria-hidden="true"></i>
            快讯
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-[kanliao-ticker_32s_linear_infinite] items-center gap-10 py-2 pl-6 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-400"></span>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* dual column hero */}
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-5 pb-16 pt-12 md:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:pb-24 lg:pt-16">
        {/* left text */}
        <div>
          <div className="mb-5 flex items-center gap-3">
            <span className="font-label text-[11px] font-semibold uppercase tracking-[0.28em] text-primary-600">
              KANLIAO · 今日猛料
            </span>
            <span className="hidden h-px flex-1 bg-primary-200 sm:block"></span>
          </div>

          <h1 className="font-heading text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-5xl lg:text-[3.4rem]">
            全网在吃什么瓜，
            <br />
            打开就<span className="relative whitespace-nowrap text-primary-600">见分晓
              <span className="absolute -bottom-1 left-0 h-2 w-full -rotate-1 bg-accent-200/80"></span>
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            不用翻遍各平台，看料网替你盯住热搜、论坛与路透。今日新料、最新爆料合集、热门大瓜盘点与全网吃瓜汇总，实时滚动更新，开页就能掌握当下热点事件与吃瓜方向。
          </p>

          {/* meta stats */}
          <div className="mt-8 flex flex-wrap items-center gap-x-10 gap-y-4">
            {heroStats.map((s) => (
              <div key={s.label} className="flex items-baseline gap-2">
                <span className="font-heading text-3xl font-black text-foreground-950">{s.value}</span>
                <span className="text-sm text-secondary-700">{s.label}</span>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#today"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              看今日热度榜
              <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
            </a>
            <a
              href="#leaks"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-newspaper-line text-base" aria-hidden="true"></i>
              进入最新爆料合集
            </a>
          </div>
        </div>

        {/* right image */}
        <div className="relative lg:pl-2">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=overhead%20editorial%20flatlay%20of%20a%20smartphone%20buried%20under%20popping%20newspaper%20cutouts%2C%20polaroid%20photos%20and%20red%20ribbon%20headlines%20on%20a%20warm%20cream%20desk%2C%20dramatic%20hot%20spotlight%2C%20gossip%20buzz%20concept%2C%20vintage%20magazine%20collage%20aesthetic%2C%20vermilion%20and%20amber%20tones%2C%20high%20detail%20cinematic%20still%20life&width=760&height=900&seq=kl-hero-main&orientation=portrait"
              alt="看料网今日猛料封面图"
              className="h-[420px] w-full object-cover object-center lg:h-[560px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent"></div>
            <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1.5 text-xs font-semibold text-primary-700 backdrop-blur">
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
              今日 1 号瓜
            </span>
            <div className="absolute bottom-4 left-4 right-4">
              <span className="mb-2 inline-block rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                热度飙升
              </span>
              <p className="font-heading text-lg font-bold leading-snug text-background-50">
                顶流直播翻车：从控评反噬到全员下场，这一晚发生了什么
              </p>
            </div>
          </div>
          {/* floating stat */}
          <div className="absolute -right-3 top-6 hidden rounded-xl bg-background-50 p-3 shadow-sm ring-1 ring-background-200 lg:block">
            <div className="flex items-center gap-2">
              <span className="grid h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">+18.2%</p>
                <p className="text-[11px] text-secondary-600">5 分钟热度</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}